import { RegistrationAddressT } from './address';
import { LoanPurposeValueT } from './borrowing-needs';
import { MaritalInformationFormT } from './marital-status';

export type RegistrationDataT = {
  address: RegistrationAddressT;
  dateOfBirth: string;
  email: string;
  firstName: string;
  lastName: string;
  loanAmount: number;
  loanPurpose: LoanPurposeValueT;
  phoneNumber: string;
  emailCodeHasToken?: boolean;
  maritalInformation?: MaritalInformationFormT;
};

// Listed in the order in which they appear in the consent bundle.
export type ConsentTypeT =
  | 'consent_to_small_dollar_rule_ecommunication'
  | 'consent_to_electronic_communications'
  | 'consent_to_obtain_credit_reports'
  | 'consent_to_privacy_policy'
  | 'delaware_disclosure'
;

export const applicationDecisions = [
  'declined',
  'installment_approved',
  'loc_approved',
  'multi_product_approved',
] as const;

export type ApplicationDecisionT = (typeof applicationDecisions)[number];
